import { trackScroll75 as trackGA4 } from './analytics';
import { useEffect } from 'react';

interface ScrollTrackerOptions {
  threshold?: number;
  once?: boolean;
}

export function trackScroll(options: ScrollTrackerOptions = {}) {
  const { threshold = 0.75, once = true } = options;

  if (typeof window === 'undefined') return;

  let hasTracked = false;

  const onScroll = () => {
    const scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;

    if (scrolled >= threshold && (!hasTracked || !once)) {
      trackGA4(window.location.pathname);
      hasTracked = true;

      if (once) {
        window.removeEventListener('scroll', onScroll);
      }
    }
  };

  // Use passive listener for better performance
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.addEventListener('scroll', onScroll, { passive: true } as any);

  // Also check on load in case content is short
  setTimeout(onScroll, 100);

  // Return cleanup function
  return () => {
    window.removeEventListener('scroll', onScroll);
  };
}

// React hook for scroll tracking
export function useScrollTracking(options: ScrollTrackerOptions = {}) {
  const { threshold = 0.75, once = true } = options;

  useEffect(() => {
    return trackScroll({ threshold, once });
  }, [threshold, once]);
}
